module.exports = {
    "baseUrl": "https://api.primrose.health",
    "ClinicBaseUrl": "https://api-v4.primrose.health",
    "systemName": "System Prod"
}